module.exports = __webpack_public_path__ + "static/media/badge_challenge_1.0c791a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_challenge_1.png
// module id = 484
// module chunks = 0